export const variantPrice = variant => Number(variant?.onlinePrice ?? variant?.mrp ?? 0);

export function matchingVariant(variants, sizeId, colorId) {
  const matches = variants.filter(v => (!sizeId || v.size?.id === sizeId) && (!colorId || v.color?.id === colorId));
  return matches.find(v => v.isInStock) || matches[0] || null;
}

export function priceSummary(variants) {
  const available = variants.filter(v => v.isInStock);
  const priced = (available.length ? available : variants).filter(v => variantPrice(v) > 0).sort((a,b) => variantPrice(a)-variantPrice(b));
  return { variant: priced[0] || null, price: variantPrice(priced[0]), varies: new Set(priced.map(variantPrice)).size > 1 };
}

export function imagesForColor(images, variants, colorId) {
  if (!colorId) return images;
  const ids = new Set(variants.filter(v => v.color?.id === colorId).map(v => v.id));
  const specific = images.filter(image => ids.has(image.variantId));
  const generic = images.filter(image => !image.variantId);
  return specific.length ? [...specific, ...generic] : generic;
}
